import { AfterContentInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild, } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ProductReferenceService, RoutingService, } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as __ from 'lodash';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as _ from 'underscore';
import { CustomProdPgService } from '../../custom-prod-pg/custom-prod-pg.service';
import * as config from '../../shared/config/app.config';
import { CartsApi } from '../../shared/model/cart.model';
import { ContractConditions, ContractControls } from '../../shared/model/contract-conditions.model';
import { PriceChannel } from '../../shared/model/price-channel.model';
import { PriceGroup } from '../../shared/model/price-group.model';
import { CustomProduct, CustomProductApiParams } from '../../shared/model/product.model';
import { StockAvailableStatus } from '../../shared/model/stock-available-status';
import { BaseService } from '../../shared/services/base.service';
import { DataLayerService } from '../../shared/services/data-layer.service';
import { ProductUtils } from '../../shared/utils/productUtils';
import { SubscriptionsContainer } from '../../shared/utils/subscriptions-container';
import { CustomPdpService } from '../custom-pdp.service';

@Component({
  selector: 'app-custom-pdp',
  templateUrl: './custom-pdp.component.html',
  styleUrls: ['./custom-pdp.component.scss'],
  standalone: false
})
export class CustomPdpComponent implements OnInit, OnDestroy, AfterContentInit {
  private readonly successMessageTimeout = 2500;
  protected readonly PriceChannel = PriceChannel;
  protected readonly StockAvailableStatus = StockAvailableStatus;
  flagRemoved: boolean = false;
  productCode: string;
  productDetails: any;
  monographLink: any;
  monograph: any;
  buttonName = 'Login to order';
  panelVolumeExpanded = false;
  panelProductExpanded = false;
  userDetails: any;
  relatedProducts = [];
  relatedProductsFormatted: any;
  @ViewChild('p2') public successPopover: NgbPopover;
  successMsg = false;
  fallbackImage = 'i18n-assets/sanofiwebb_missing_product.png';
  description: any;
  cartId: any;
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    infinite: true,
    arrows: true,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 3, slidesToScroll: 3 } },
      { breakpoint: 1100, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };
  displaySection = false;
  itemAddedQuantity: any;
  cartItems: CartsApi[];
  slickInit(e): void { return }
  breakpoint(e): void { return }
  afterChange(e): void { return }
  beforeChange(e): void { return }
  updateErrorSub: Subscription;
  cartDetailsSub: Subscription;
  userSub: Subscription;
  cartItemsSub: Subscription;
  productCodeSub: Subscription;
  relatedProdSub: Subscription;
  selectedChannel: PriceChannel;
  contractFromCartApi: string;
  contractSelectedId: string;
  enableBtn: boolean = false;
  productInfo: CustomProduct;
  hasMatchingContract: boolean;
  carts: any;
  userId: string;
  subs = new SubscriptionsContainer();
  contractSelected: ContractConditions;
  priceToShow: number;
  priceToShowGroupId: string;
  priceGroupToShow: any;
  showPriceGroup: boolean = false;
  conditionsForCartonsLogicMeet = false;
  protected readonly ProductUtils = ProductUtils;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly routerservice: RoutingService,
    private readonly user: UserAccountFacade,
    private readonly pdpService: CustomPdpService,
    private readonly referenceService: ProductReferenceService,
    private readonly cdr: ChangeDetectorRef,
    private readonly routingService: RoutingService,
    private readonly modalService: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly dataLayerService: DataLayerService,
    protected readonly modal: NgbModal,
    private readonly plpService: CustomProdPgService,
    private readonly baseService: BaseService
  ) {
  }

  ngOnInit(): void {
    this.selectedChannel = sessionStorage.getItem('selectedChannel') as PriceChannel;
    this.contractFromCartApi = sessionStorage.getItem('contractFromCartApi');

    this.route.params.forEach((params: Params) => {
      this.populatePDP();
    });

    if (this.selectedChannel === PriceChannel.PRIVATE) {
      this.enableBtn = true;
    }
  }

  populatePDP(): void {
    this.productDetails = [];
    this.productCode = this.route.snapshot.params.productCode;

    this.userSub = this.user.get()
      .pipe(
        filter(user => !!user),
      )
      .subscribe((res) => {
        this.userDetails = res;
        this.userId = res.uid;
        this.pdpService.getCarts(this.userDetails?.userName);
        this.pdpService.getPDPCategory(this.productCode);
      });

    this.cartItemsSub = this.pdpService.cartItems$.subscribe(res => {
      if (!res) {
        return;
      }

      this.cartItems = res?.carts.filter(item => item?.saveTime === undefined);
    });

    this.productCodeSub = this.pdpService.productCode$
      .pipe(
        filter(productCode => !!productCode),
      )
      .subscribe((res) => {
        this.productInfo = res;

        this.conditionsForCartonsLogicMeet = ProductUtils.channelPrivateAndNumberUnitsPerCartonMoreThanOne(
          this.productInfo.numberOfUnitsPerCarton,
          this.selectedChannel
        );

        if (this.userId) {
          this.getCarts(this.userId, res);
        }

        this.displaySection = res.hasOwnProperty('code');
        this.productDetails = res;
        this.description = this.sanitizer.bypassSecurityTrustHtml(
          this.productDetails.description
        );
        this.monograph = this.productDetails?.productDocuments;
        if (this.monograph) {
          for (const link of this.monograph?.productDocument) {
            this.monographLink = this.sanitizer.bypassSecurityTrustResourceUrl(
              link.url
            );
          }
        }
        if (this.userDetails !== undefined) {
          if (this.productDetails.flu === true) {
            this.buttonName = 'Reserve now';
          } else {
            this.buttonName = 'Add to cart';
          }
        } else {
          this.buttonName = 'Login to order';
        }
        this.dataLayerService.viewItemDataLayer(res, 'standard process', 'pdp');
        this.cdr.detectChanges();
      });
    this.relatedProdSub = this.referenceService
      .getProductReferences(this.productCode, '')
      .subscribe((res) => {
        if (res && res.length > 0) {
          this.relatedProducts = _.pluck(res, 'target');
          this.relatedProducts = _.filter(
            this.relatedProducts,
            function(prod) {
              return prod.displayProduct;
            }
          );

          this.cdr.detectChanges();
        }
      });
  }

  showSelectedContract(contract: ContractConditions): void {
    this.contractSelectedId = contract?.contractId;
    this.contractSelected = contract;
    if (contract && contract?.priceGroups?.length === 1) {
      this.enableBtn = true;
      this.priceToShow = contract?.priceGroups[0]?.priceData?.value;
      this.priceToShowGroupId = contract?.priceGroups[0]?.groupId;
    } else {
      this.priceGroupToShow = contract?.priceGroups;
      this.enableBtn = false;
      this.priceToShow = null;
      this.priceToShowGroupId = null;
    }
  }

  showSelectPriceGroup(priceGroup: PriceGroup): void {
    this.priceToShow = priceGroup?.priceData?.value;
    this.priceToShowGroupId = priceGroup?.groupId;
    this.enableBtn = true;
  }

  openModal(content: TemplateRef<any>, prodCode: string): void {
    // check if there is contract already
    if (!!sessionStorage.getItem('contractFromCartApi') || this.selectedChannel === PriceChannel.PRIVATE || !this.selectedChannel) {
      this.addToCart(prodCode);
    } else {
      this.modal.open(content, {
        centered: true,
        backdrop: 'static',
      });
    }
  }

  addToCart(productCode: string): void {
    this.successMsg = true;
    const inputElement = document.getElementById(`prodQuantity${productCode}`) as HTMLInputElement;
    this.itemAddedQuantity = inputElement.value;
    //set params for private channel
    let params: CustomProductApiParams;
    const defaultParams = {
      product: { code: productCode },
      quantity: inputElement.value,
    };

    params = { ...defaultParams };

    //set params for public should include contractId
    if (this.selectedChannel === PriceChannel.PUBLIC) {
      const extraParams = {
        contractId: this.contractSelected?.contractId,
        contractName: this.contractSelected?.contractName
          ? this.contractSelected?.contractName
          : '',
        groupId: this.priceToShowGroupId,
      };
      params = { ...defaultParams, ...extraParams };
    }

    // Check carts - get info then Update cart
    if (this.carts && this.carts?.length === 0) {
      this.plpService.createCart(this.userDetails?.userName);
      this.plpService.createdCart$.subscribe((res) => {
        if (res) {
          this.cartId = res?.code;
          this.plpService.getCarts(this.userDetails?.userName);
          this.updateCartDetails(params, this.cartId);
        }
      });
    } else {
      const cartId = this.carts[0]?.code;
      this.updateCartDetails(params, cartId);
    }
  }

  performQuantityComputation(operator: number | null): void {
    ProductUtils.alterQuantity(
      operator,
      this.productInfo.code,
      this.productInfo.quantityPerUnit,
      this.selectedChannel,
      this.conditionsForCartonsLogicMeet ? this.productInfo.numberOfUnitsPerCarton : 0
    );
  }

  goToLogin(): void {
    this.routingService.goByUrl('/login');
  }

  openImage(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      windowClass: 'carousel-modal',
    });
  }

  navigateToFlu(): void {
    this.routerservice.goByUrl('/influenza/dashboard');
  }

  ngOnDestroy(): void {
    this.pdpService.productCode.next(null);
    this.displaySection = false;
    this.cartDetailsSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.productCodeSub?.unsubscribe();
    this.relatedProdSub?.unsubscribe();
    this.updateErrorSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.subs.dispose();
  }

  ngAfterContentInit(): void {
    const elementsWithSummary = document.getElementsByClassName('Summary');
    // @ts-ignore
    for (const el of elementsWithSummary) {
      el.classList.remove('Summary');
    }
  }

  private getCarts(userId: string, product: CustomProduct): void {
    this.subs.add(this.baseService
      .get(config.USER_ACCOUNT + userId + '/carts')
      .subscribe((cart) => {
        this.carts = __.remove(cart?.carts, function(n) {
          return !n.savedBy;
        });

        if (this.carts?.length === 0 || this.carts[0]?.childCarts?.length === 0) {
          this.noCart(product);
        } else {
          // Item in cart let's go
          this.contractFromCartApi = this.carts[0]?.childCarts[0]?.contractId;

          if (__.some(product?.conditions, ['contractId', this.contractFromCartApi,]) === true) {
            this.hasMatchingContract = true;
            this.hasCartAndMatchingContract(product);
          } else {
            this.hasMatchingContract = false;
          }
        }
        this.cdr.detectChanges();
      }));
  }

  private hasCartAndMatchingContract(product: CustomProduct): void {
    const cond = product?.conditions;
    const cont = cond.find(item => item.contractId === this.contractFromCartApi);
    this.contractSelected = cont;
    this.priceGroupToShow = cont?.priceGroups;
    if (this.priceGroupToShow.length > 1) {
      this.enableBtn = false;
      this.showPriceGroup = true;
      this.contractSelectedId = cont?.contractId;
    } else {
      this.enableBtn = true;
      this.priceToShow = cont?.priceGroups[0]?.priceData?.value;
      this.priceToShowGroupId = cont?.priceGroups[0]?.groupId;
      this.contractSelectedId = cont?.contractId;
    }
  }

  private noCart(product: CustomProduct): void {
    if (this.selectedChannel === PriceChannel.PRIVATE) {
      return;
    }
    if (product?.conditions && product?.conditions?.length === 1) {
      this.contractSelectedId = product?.conditions[0]?.contractId;
      this.contractSelected = product?.conditions[0];
      if (product?.conditions[0]?.priceGroups.length === 1) {
        this.enableBtn = true;
        this.priceToShow = product?.conditions[0]?.priceGroups[0]?.priceData?.value;
        this.priceToShowGroupId = product?.conditions[0]?.priceGroups[0]?.groupId;
      } else {
        this.enableBtn = false;
        this.priceGroupToShow = product?.conditions[0]?.priceGroups;
      }
    }
  }

  private updateCartDetails(params: CustomProductApiParams, cartId: string): void {
    if (this.userId && cartId) {
      this.plpService.updateCart(params, this.userId, cartId);

      this.cartDetailsSub = this.plpService.cartDetailsUpdate$.subscribe(res => {
          if (!res) {
            this.cdr.detectChanges();
            return;
          }

          if (this.successMsg) {
            this.successPopover.open();
            setTimeout(() => this.successPopover.close(), this.successMessageTimeout);
            this.successMsg = false;
            if (this.selectedChannel === PriceChannel.PUBLIC && !sessionStorage.getItem('contractFromCartApi')) {
              sessionStorage.setItem('contractFromCartApi', params?.contractId);
              window.location.reload();
            }
          }

          this.cdr.detectChanges();
        }
      );

      this.updateErrorSub = this.plpService.updateError$.subscribe((res) => {
        if (res) {
          this.successMsg = false;
        }
      });
    }
    this.cdr.detectChanges();
  }

  onSelectedContract(controls: ContractControls) {
    this.enableBtn = controls.enableBtn;
    this.priceToShow = controls.priceToShow;
    this.contractSelectedId = controls.contractSelected.contractId;
    this.priceToShowGroupId = controls.priceToShowGroupId;
    this.priceGroupToShow = controls.priceGroupToShow;
    this.contractSelected = controls.contractSelected;
  }

  onSelectPriceGroup(controls: ContractControls) {
    this.enableBtn = controls.enableBtn;
    this.priceToShow = controls.priceToShow;
    this.priceGroupToShow = controls.priceGroupToShow;
  }
}
